<p class="titleBox">
  <strong class="title">Results:</strong>
  {{ projectOne }} vs. {{ projectTwo }}
</p>

<usimweb-dropdown
  class="result-menu"
  placeholder="Plot type"
  [values]="plotTypes"
  [key]="key"
  [value]="value"
  [default]="plotType"
  [width]="width"
  (selectionChange)="selectedPlotType($event)"
  [required]="true"
></usimweb-dropdown>

<usimweb-plot divId="plotDiv" [data]="plotData" [layout]="plotLayout"></usimweb-plot>
